import { BaseController } from '~client/controller/base-controller';
import { UserProfileEditRequest } from '~client/model/user-profile-edit-request';
import { UserProfileResponse } from '~client/model/user-profile-response';

/* User APIs to create, update and view personal user profile information */
export class UserProfileController extends BaseController {
  /* Allows the user to view their profile */
  public getProfile(): Promise<UserProfileResponse> {
    return this.get('/user/profile');
  }

  /* Allows the user to update their profile */
  public updateProfile(request: UserProfileEditRequest): Promise<UserProfileResponse> {
    return this.put('/user/profile', request);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/user-profile-controller.ts